import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    menuStoreId: null,
    latestVersions: {}, // 存 server 上各 variation 最新的版本
    menus: {},
    menuVariations: [],
    businessHours: {},
    businessHourDirtyStates: {}
  },
  getters: {
  },
  mutations,
  actions
}
